import { Box } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getLottieById } from '../../../../modules/user/pages/activities/activitiesActions';
import LottieControl from '../../lottie/lottie';
import DOMPurify from 'dompurify';
import { BASE_S3 } from 'config/consts';

let NewFeedbackContent = function (props) {
  const [feedback, setFeedback] = useState('');
  const [lottieId, setLottieId] = useState(0);

  useEffect(() => {
    for (let i of props.quizFeedbacks) {
      if (parseFloat(props.percentage) <= parseFloat(i.range)) {
        setFeedback(i.feedback);
        setLottieId(i.feedback_lottie_id);
        break;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.percentage]);

  useEffect(() => {
    if (lottieId) props.getLottieById(lottieId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lottieId]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      style={{ width: '100%', height: '95vh' }}
    >
      {lottieId && props.lottie.json ? (
        <LottieControl loop={false} animation={props.lottie.json} />
      ) : null}
      <div
        style={{ maxWidth: '35em' }}
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(feedback) }}
      />
      {props.trophyImage && props.trophyDescription ? (
        <>
          <img
            src={`${BASE_S3}/${props.trophyImage}`}
            alt={props.trophyDescription}
            style={{ maxWidth: '200px', marginTop: '1.5em' }}
          />
          <p style={{ marginTop: '0.5em', textAlign: 'center', fontWeight: 'bold' }}>
            {props.trophyDescription}
          </p>
        </>
      ) : null}
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getLottieById,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(NewFeedbackContent);
